import { gql } from 'graphql-tag'

export const CREATE_CONSUMER_SUPPORT_CASE = gql`
  mutation createConsumerSupportCase($caseInput: CreateConsumerSupportCaseInput!) {
    createConsumerSupportCase(caseInput: $caseInput) {
      caseId
      caseCategory
      caseDetails
      clientId
      orderId
      packageId
      taskCreated
    }
  }
`
